<template>
  <div class="progress-bar">
    <p>
      Viser {{ thousandSeparator(currentNumberOfResults) }} ud af
      {{ thousandSeparator(numberOfResults) }}
      {{ searchType }}
    </p>
    <div class="progress-bar__bar">
      <div
        class="progress-bar__bar-progress"
        :style="{
          width: (currentNumberOfResults / numberOfResults) * 100 + '%',
        }"
      ></div>
    </div>
  </div>
</template>

<script>
import { thousandSeparator } from '@/functions'

export default {
  props: {
    numberOfResults: { default: 0, type: Number },
    currentNumberOfResults: { default: 0, type: Number },
    searchType: { default: '', type: String },
  },
  methods: {
    thousandSeparator(value) {
      return thousandSeparator(value)
    },
  },
}
</script>

<style lang="scss">
@import 'ProgressBar.scss';
</style>
